var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9013 9C12.1079 9 9.03275 12.0752 9.03275 15.8685C9.03275 19.6619 12.1079 22.7371 15.9013 22.7371C17.5063 22.7371 18.9827 22.1866 20.1521 21.2641L25.6645 26.7765C25.9625 27.0745 26.4457 27.0745 26.7437 26.7765C27.0418 26.4784 27.0418 25.9952 26.7437 25.6972L21.2386 20.1921C22.1961 19.0115 22.7698 17.507 22.7698 15.8685C22.7698 12.0752 19.6947 9 15.9013 9ZM10.5591 15.8685C10.5591 12.9181 12.9509 10.5263 15.9013 10.5263C18.8517 10.5263 21.2435 12.9181 21.2435 15.8685C21.2435 18.819 18.8517 21.2107 15.9013 21.2107C12.9509 21.2107 10.5591 18.819 10.5591 15.8685Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b737fc655c19100deee1aed9cee625fa.svg";
export { ForwardRef as ReactComponent };